// extracted by mini-css-extract-plugin
export default {"line":"ShimmerLoader_line__LYbVo","shimmer":"ShimmerLoader_shimmer__u5BIw"};